import React from 'react';
import { useAppSelector } from '../store/hooks';
import { selectModalOnboarding } from '../store/onboardingSlice';
import { selectBaseUrl, selectStageCheckList } from '../store/kickoffSlice';
import { GenericUpdateForm } from '../OnboardingViewModal';
import { Checklist } from './OnboardingViewHelpers';
import './KickoffModal.css';

const KickoffModal = () => {
  // Redux state
  const modalOnboarding = useAppSelector(selectModalOnboarding);
  const baseUrl = useAppSelector(selectBaseUrl);
  const stageCheckList = useAppSelector(selectStageCheckList);

  const kickoff = modalOnboarding?.kickoff;

  const formatDate = (dateString) => {
    if (!dateString) return 'Not set';
    return new Date(dateString).toLocaleDateString();
  };

  return (
    <div className="space-y-4">
      { modalOnboarding && (
        <div>
          <h3 className="kickoff-title">Kickoff</h3>
          <p className="kickoff-date">{formatDate(kickoff)}</p>
          <GenericUpdateForm onboarding={modalOnboarding} stage="kickoff" baseUrl={baseUrl} />
          
          {/* Checklist Component */}
          <Checklist 
            stage="kickoff" 
            onboarding={modalOnboarding} 
            stateCheckList={stageCheckList} 
          />
        </div>
      )}
    </div>
  );
};

export const displayHistoryKickoff = (onboarding) => {
  // For now, return a simple table row with placeholder data
  // In the future, this would parse actual history data from the onboarding object
  return (
    <tr className="kickoff-history-row">
      <td className="kickoff-history-cell">
        {new Date().toLocaleString()}
      </td>
      <td className="kickoff-history-cell">
        Not set
      </td>
      <td className="kickoff-history-cell">
        {onboarding.kickoff ? new Date(onboarding.kickoff).toLocaleDateString() : 'Not set'}
      </td>
      <td className="kickoff-history-cell">
        Initial status
      </td>
    </tr>
  );
};

export { KickoffModal };
